import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import AddItemCard from '../../generic-components/add-item-card/add-item-card';
import EditButton from '../../generic-components/edit-button';
import MouseOverEditDiv from '../../../tc-ui/mouse-over-edit-div';
import ExpandableTextBlock from '../../../tc-ui/expandable-text-block';
import HelperLink from '../product/helper-link';

const TermsCriteria = ({
  corporateIdentificationNumber,
  deadlineDate,
  editable,
  forSupplier,
  inMaster,
  marketInfo,
  openAddEditContractDialog,
  style,
  submissionCriteria,
  termsAndConditions,
}) => {
  const editNotes = action => () => openAddEditContractDialog({
    type: 'submissionCriteria',
    title: `${action} notes`,
    policiesNotesPage: true,
    data: { forSupplier },
  });
  const editTerms = action => () => openAddEditContractDialog({
    type: 'termsAndConditions',
    title: `${action} terms and conditions`,
    policiesNotesPage: true,
    data: { forSupplier },
  });
  const editMarketInfo = action => () => openAddEditContractDialog({
    type: 'marketInfo',
    title: `${action} market information`,
    policiesNotesPage: true,
    data: { forSupplier },
  });
  const termsNode = (() => {
    if (termsAndConditions) return termsAndConditions;
    return (
      <AddItemCard
        text="Add terms and conditions"
        onClick={editTerms('Add')}
        editable={editable}
      />
    );
  })();
  const submissionNode = (() => {
    if (submissionCriteria) return submissionCriteria;
    return (
      <AddItemCard
        text="Add notes"
        onClick={editNotes('Add')}
        editable={editable}
      />
    );
  })();
  const marketInfoNode = (() => {
    if (marketInfo) return marketInfo;
    return (
      <AddItemCard
        text="Add market information"
        onClick={editMarketInfo('Add')}
        editable={editable}
      />
    );
  })();
  return (
    <div style={{ marginLeft: '15%', marginBottom: '24px', width: '80%', paddingTop: '24px', whiteSpace: 'pre-wrap', ...style }}>
      <div style={{ marginBottom: '12px', fontSize: '16px' }}>GENERAL CONTRACT NOTES</div>
      <div style={{ marginLeft: '32px' }}>
        { deadlineDate && (
        <div>
          <div style={{ fontWeight: 'bolder' }}>Rate Submission Deadline</div>
          <div style={{ margin: '1em 0 1em 0' }}>{ moment.utc(new Date(deadlineDate)).format('MMMM DD, YYYY') }</div>
        </div>
        ) }
        <HelperLink
          openEditDialog={editNotes('Edit')}
          value="submissionCriteria"
          labelText="Notes"
          justLabel={inMaster}
        />
        <MouseOverEditDiv
          editable={editable && Boolean(submissionCriteria)}
          actionButtons={(
            <EditButton
              onEdit={editNotes('Edit')}
            />
          )}
          singleLineTitle
        >
          {Boolean(submissionCriteria) && <br />}
          <ExpandableTextBlock
            style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}
          >
            {submissionNode}
          </ExpandableTextBlock>
          <br />
        </MouseOverEditDiv>
        <HelperLink
          openEditDialog={editTerms('Edit')}
          value="termsAndConditions"
          labelText="Terms & conditions"
          justLabel={inMaster}
        />
        <MouseOverEditDiv
          editable={editable && Boolean(termsAndConditions)}
          actionButtons={<EditButton onEdit={editTerms('Edit')}/>}
          singleLineTitle
        >
          {Boolean(termsAndConditions) && <br />}
          <ExpandableTextBlock
            style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}
          >
            {termsNode}
          </ExpandableTextBlock>
          <br />
        </MouseOverEditDiv>
        {
          forSupplier ? (
            <div>
              <HelperLink
                openEditDialog={editMarketInfo('Edit')}
                value="marketInfo"
                labelText="Market Information (FIT, Group, Markets, etc.)"
                justLabel={inMaster}
              />
              <MouseOverEditDiv
                editable={editable && Boolean(marketInfo)}
                actionButtons={<EditButton onEdit={editMarketInfo('Edit')} />}
                singleLineTitle
              >
                {Boolean(marketInfo) && <br/>}
                <div>{marketInfoNode}</div>
                <br />
              </MouseOverEditDiv>
            </div>
          ) : (
            <div>
              <div style={{ fontWeight: 'bolder' }}>
                  Corporate identifier/tax id
              </div>
              <MouseOverEditDiv
                editable={editable}
                actionButtons={<EditButton onEdit={() => openAddEditContractDialog({ type: 'corporateIdentificationNumber', title: 'Update corporate identification number', data: { forSupplier } })} />}
                singleLineTitle
              >
                {
                  Boolean(corporateIdentificationNumber) ? (
                    <div style={{ marginTop: '1em' }}>{corporateIdentificationNumber}</div>
                  ) : (
                    <div style={{ color: 'rgba(0, 0, 0, 0.34)' }}>NA</div>
                  )
                }
                <br />
              </MouseOverEditDiv>
            </div>
          )
        }
      </div>
    </div>
  );
};

TermsCriteria.propTypes = {
  contractState: PropTypes.string,
  corporateIdentificationNumber: PropTypes.string,
  deadlineDate: PropTypes.string,
  editable: PropTypes.bool,
  forSupplier: PropTypes.bool,
  inMaster: PropTypes.bool,
  marketInfo: PropTypes.string,
  openAddEditContractDialog: PropTypes.func,
  style: PropTypes.object,
  submissionCriteria: PropTypes.string,
  termsAndConditions: PropTypes.string,
};

export default TermsCriteria;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-policies/terms-criteria-node.jsx